import React from 'react';
import { motion } from 'framer-motion';
import CordycepsHeroVideo from './CordycepsHeroVideo';

const Hero = () => {
  return (
    <>
      <section style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        paddingTop: '110px',
        paddingBottom: '80px',
        background: '#000000',
        borderBottom: '1px solid #1c1c1c'
      }}>
        <div className="container hero-container" style={{
          display: 'grid',
          gap: '48px',
          alignItems: 'center',
          width: '100%',
        }}>
          {/* Left Side: Editorial Typography & Clean Telemetry */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: '#0a0a0a',
                border: '1px solid #333333',
                color: '#ffffff',
                padding: '6px 14px',
                borderRadius: '4px',
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                marginBottom: '28px'
              }}
              className="hero-badge"
            >
              <span>Third-party lab-tested for safety · FSSAI licence applied</span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              style={{
                fontSize: 'clamp(3.2rem, 6.5vw, 5.4rem)',
                lineHeight: 0.96,
                letterSpacing: '-0.05em',
                marginBottom: '28px',
                color: '#ffffff',
                fontWeight: 900
              }}
              className="hero-title"
            >
              PURE <br />
              CORDYCEPS <br />
              MILITARIS.
            </motion.h1>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7, delay: 0.25 }}
              style={{
                fontSize: '1.15rem',
                color: '#888888',
                lineHeight: 1.65,
                marginBottom: '40px',
                maxWidth: '520px',
                fontWeight: 400
              }}
            >
              Whole Cordyceps militaris — cultivated on our own substrate, low-heat dried, and third-party lab-tested for heavy metals and microbial safety. No fillers, no inflated claims. Just the mushroom, in five honest formats.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.4 }}
              style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: '48px' }}
              className="hero-buttons"
            >
              <a
                href="#products"
                className="btn-mono-primary"
                style={{ textDecoration: 'none', textAlign: 'center' }}
              >
                Explore Collection
              </a>

              <a
                href="#science"
                className="btn-mono-outline"
                style={{ textDecoration: 'none', textAlign: 'center' }}
              >
                The Science
              </a>
            </motion.div>

            {/* Minimalist Grid Stats */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '16px',
              borderTop: '1px solid #1c1c1c',
              paddingTop: '28px'
            }}>
              <div>
                <div style={{ fontSize: '1.8rem', fontWeight: 900, color: '#ffffff', letterSpacing: '-0.04em' }}>100%</div>
                <div style={{ fontSize: '0.78rem', color: '#666666', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: '4px' }}>Fruiting Body</div>
              </div>
              <div>
                <div style={{ fontSize: '1.8rem', fontWeight: 900, color: '#ffffff', letterSpacing: '-0.04em' }}>0</div>
                <div style={{ fontSize: '0.78rem', color: '#666666', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: '4px' }}>Fillers Added</div>
              </div>
              <div>
                <div style={{ fontSize: '1.8rem', fontWeight: 900, color: '#ffffff', letterSpacing: '-0.04em' }}>5</div>
                <div style={{ fontSize: '0.78rem', color: '#666666', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: '4px' }}>Honest Formats</div>
              </div>
            </div>
          </div>

          {/* Right Side: Real Cordyceps militaris turntable, rotated by scroll */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.2 }}
            style={{ height: '600px', width: '100%' }}
            className="hero-video-container"
          >
            <CordycepsHeroVideo />
          </motion.div>
        </div>
      </section>

      <style>{`
        .hero-container {
          grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
        }
        @media (max-width: 768px) {
          .hero-container {
            grid-template-columns: 1fr;
            gap: 24px !important;
            padding-top: 24px;
          }
          .hero-badge {
            font-size: 0.65rem !important;
            line-height: 1.4 !important;
          }
          .hero-title {
            font-size: clamp(2.8rem, 12vw, 3.5rem) !important;
            margin-bottom: 20px !important;
          }
          .hero-buttons {
            flex-direction: column;
            width: 100%;
          }
          .hero-buttons a {
            width: 100%;
          }
          .hero-video-container {
            height: 400px !important;
          }
        }
      `}</style>
    </>
  );
};

export default Hero;
